require('./score-analysis.jade')

ScoreAnalysisDirective = ->
  createChartOptions = (data, element) ->
    chart:
      renderTo: element[0]
      type: 'pie'
      backgroundColor: 'transparent'
    plotOptions:
      pie:
        borderWidth: 0
        shadow: false
        startAngle: -90
        endAngle: 90
        center: [
          '50%'
          '50%'
        ]
        enableMouseTracking: false
        dataLabels:
          enabled: false
    tooltip:
      enabled: false
    title:
      floating: true
      y: 28
      text: ''
    credits:
      enabled: false
    series: [
      threshold: 1
      size: '100%'
      innerSize: '85%'
      data: [
        color: '#ff0000'
        y: data.rat_under_eagle
      ,
        color: '#ff7400'
        y: data.rat_birdie
      ,
        color: '#05a2d3'
        y: data.rat_par
      ,
        color: '#215605'
        y: data.rat_bogey
      ,
        color: '#3a3a3a'
        y: data.rat_dbogey
      ,
        color: '#000000'
        y: data.rat_over_tbogey
      ]
    ]

  restrict: "A"
  replace: false
  templateUrl: "analysis-charts/score-analysis/score-analysis.jade"
  scope:
    scoreData: '=scoreData'
  link: (scope, element) ->
    target = element.find(".score-chart")
    scope.$watch (-> scope.scoreData), ->
      return if not scope.scoreData.rat_birdie and
        not scope.scoreData.rat_bogey and
        not scope.scoreData.rat_dbogey and
        not scope.scoreData.rat_over_tbogey and
        not scope.scoreData.rat_par and
        not scope.scoreData.rat_under_eagle

      new Highcharts.Chart createChartOptions(scope.scoreData, target)

module.exports = ScoreAnalysisDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/analysis-charts/score-analysis/score-analysis-directive.coffee